import { Capacitor } from "@capacitor/core";

/**
 * ブラウザ開発時は空のまま → `/api` が Vite のプロキシ経由になる。
 * 実機（Capacitor / スマホの Safari）では LAN IP を指定:
 * VITE_API_BASE_URL=http://192.168.1.10:3001
 *
 * .env に LAN URL があっても、PC で localhost:5173 を開いたときはプロキシを使う
 *（ブラウザが 192.168.x.x:3001 直叩きで失敗するのを防ぐ）。
 *
 * Capacitor の WebView も hostname は localhost になりがちだが、静的バンドルには
 * Vite プロキシがないため、ネイティブでは常に VITE_API_BASE_URL を使う。
 */
const raw = (import.meta.env.VITE_API_BASE_URL ?? "").trim();

function isLoopbackHost(): boolean {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  return h === "localhost" || h === "127.0.0.1" || h === "[::1]";
}

/** 実際に fetch に使う API のオリジン（空なら相対パス＝Vite プロキシ） */
export function effectiveApiBase(): string {
  if (Capacitor.isNativePlatform()) return raw;
  if (isLoopbackHost()) return "";
  return raw;
}

export function apiUrl(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  const base = effectiveApiBase();
  if (!base) return p;
  return `${base.replace(/\/$/, "")}${p}`;
}
